// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expansionTitle {\r\n\tcolor: black;\r\n\tbackground: blue;\r\n\t/* height: 25px; */\r\n}\r\n\r\n.svg_icon {\r\n\tcolor: #6170c2;\r\n}\r\n\r\n.svg_icon:hover {\r\n\tborder-top: double;\r\n\tborder-color: #6170c2;\r\n}\r\n\r\n.MuiExpansionPanelSummary-content {\r\n    height: 12px;\r\n}", ""]);
// Exports
module.exports = exports;
